export const PersonIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.998 1.95312C9.23665 1.95312 6.99805 4.19172 6.99805 6.95312C6.99805 9.71452 9.23665 11.9531 11.998 11.9531C14.7594 11.9531 16.998 9.71452 16.998 6.95312C16.998 4.19172 14.7594 1.95312 11.998 1.95312ZM11.998 3.95312C13.6549 3.95312 14.998 5.29622 14.998 6.95312C14.998 8.61002 13.6549 9.95312 11.998 9.95312C10.3411 9.95312 8.99805 8.61002 8.99805 6.95312C8.99805 5.29622 10.3411 3.95312 11.998 3.95312ZM8.46685 13.2656C5.85255 13.9801 3.99805 16.2533 3.99805 18.9531V20.9531C3.99805 21.5054 4.44575 21.9531 4.99805 21.9531H18.998C19.5503 21.9531 19.998 21.5054 19.998 20.9531V18.9531C19.998 16.2533 18.1435 13.9801 15.5292 13.2656C15.3051 13.2043 15.0849 13.2326 14.873 13.3281C13.9575 13.7407 12.9829 13.9531 11.998 13.9531C11.0131 13.9531 10.0385 13.7407 9.12305 13.3281C8.91115 13.2326 8.69095 13.2043 8.46685 13.2656ZM8.87305 15.2656C9.88285 15.6475 10.9177 15.9531 11.998 15.9531C13.0783 15.9531 14.1132 15.6475 15.123 15.2656C16.8264 15.7816 17.998 17.2195 17.998 18.9531V19.9531H5.99805V18.9531C5.99805 17.2195 7.16965 15.7816 8.87305 15.2656Z"
        className="oui-fill-base-contrast-80"
      />
    </svg>
  );
};
